import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { settingsOrgFlag } from 'src/store/actions/appointment.action';

import { DeleteIcon } from 'src/icons/Delete.icon';
import { useSelector } from 'react-redux';
import { Modal } from 'antd';
import { AlertIcon } from 'src/icons';
import { Button, ProfileLogo } from 'src/components';
import { Form, Formik } from 'formik';
import { getAllPractitionerListAction } from 'src/modules/SuperAdmin/store/actions';
import {
  getPractitionersOrgLevel,
  offboardUserFromOrganisation,
} from 'src/modules/SuperAdmin/store/actions/practitioner.action';
import { Sort } from 'src/icons/Sort.icon';
import { SuperAdminTable } from '../../../baseComponents/Table';
import { getAllActiveOrganizationAction } from 'src/modules/SuperAdmin/store/actions/organization.action';
import { getFromStorage } from 'src/lib/storage';
import organizationEventEmitter from 'src/utilities/organizationEmmiter';

// TODO: fix unused state

const ManageUsersPage = () => {
  const dispatch = useDispatch();

  const [selectedOrganizationGlobal, setSelectedOrganizationGlobal] = useState(
    () => {
      const savedOrg = getFromStorage('superAdminSelectedOrganization');
      return savedOrg ? JSON.parse(savedOrg) : null;
    }
  );

  const [showDeleteUserModal, setShowDeleteUserModal] = useState(false);
  const [selectedUserToDelete, setSelectedUserToDelete] = useState(null);
  const [, setOrganizationOptions] = useState([]);
  const { isLoading } = useSelector((state) => state?.conditionState);
  const [tableLoader, setTableLoader] = useState(false);
  const [persistedOrgUUID, setPersistedOrgUUID] = useState(null);
  const [, setSelectedOrganization] = useState(null);
  const { currentPractitioner } = useSelector(
    (state) => state?.practitionerState
  );
  const { practitionersOrgLevel } = useSelector((state) => state?.doctorsState);

  const { getActiveOrganizationsList } = useSelector(
    (state) => state?.organizationState
  );

  const [selectedOrganizationUUID, setSelectedOrganizationUUID] = useState(
    currentPractitioner?.org_uuid
  );
  const [, setOrganizationName] = useState(currentPractitioner?.org_id);

  useEffect(() => {
    setTableLoader(isLoading);
  }, [isLoading]);

  useEffect(() => {
    dispatch(settingsOrgFlag());
    dispatch(getAllActiveOrganizationAction());
  }, [dispatch]);

  useEffect(() => {
    if (persistedOrgUUID) {
      dispatch(getPractitionersOrgLevel(persistedOrgUUID));
    }
  }, [dispatch, persistedOrgUUID]);

  useEffect(() => {
    if (
      getActiveOrganizationsList &&
      Array.isArray(getActiveOrganizationsList)
    ) {
      let dataArr = [];
      getActiveOrganizationsList.forEach((key) => {
        dataArr.push({
          value: key?.org_id,
          label: key?.org_name,
          org_uuid: key?.org_uuid,
        });
      });
      setOrganizationOptions(dataArr);
    }
  }, [getActiveOrganizationsList]);

  const handleCloseModal = () => {
    setShowDeleteUserModal(false);
    setSelectedUserToDelete(null);
  };

  const removeUser = (selectedUser) => {
    handleCloseModal();
    dispatch(
      offboardUserFromOrganisation(
        selectedUser.practitioner_id,
        selectedOrganizationUUID
      )
    );
  };
  useEffect(() => {
    const unsubscribe = organizationEventEmitter.subscribe(
      'organizationChanged',
      (newOrg) => {
        setSelectedOrganizationGlobal(newOrg);
        onChangeHandler(null, newOrg, 'organization');
      }
    );

    return () => unsubscribe();
  }, []);

  useEffect(() => {
    if (selectedOrganizationGlobal) {
      onChangeHandler(null, selectedOrganizationGlobal, 'organization');
      setSelectedOrganization(selectedOrganizationGlobal);
      setPersistedOrgUUID(selectedOrganizationGlobal.org_uuid);
    }
  }, [selectedOrganizationGlobal]);

  const onChangeHandler = (e, value, field) => {
    if (field === 'organization') {
      setOrganizationName(value?.value);
      if (value?.value === 'All') {
        dispatch(
          getAllPractitionerListAction(currentPractitioner?.org_uuid, null)
        );
        setSelectedOrganization('All');
        setSelectedOrganizationUUID(currentPractitioner?.org_uuid);
        setPersistedOrgUUID(null);
        dispatch(getPractitionersOrgLevel(currentPractitioner?.org_uuid));
      } else {
        dispatch(getAllPractitionerListAction(value?.org_uuid, null));
        setSelectedOrganization(value?.label);
        setSelectedOrganizationUUID(value?.org_uuid);
        setPersistedOrgUUID(value?.org_uuid);
        dispatch(getPractitionersOrgLevel(value?.org_uuid));
      }
      localStorage.setItem(
        'selectedOrganizationUUID',
        value?.org_uuid || currentPractitioner?.org_uuid
      );
      localStorage.setItem('selectedOrganization', JSON.stringify(value));
    }
  };

  const doctor_nameSorter = (a, b) => {
    return a.practitioner_name.localeCompare(b.practitioner_name);
  };

  const columns = [
    {
      title: (
        <span className="font-[700]">
          {' '}
          Practitioner name <Sort className={'sort-icon-doctor'} />
        </span>
      ),
      dataIndex: 'practitioner_name',
      key: 'practitioner_name',
      width: '20%',
      sorter: doctor_nameSorter,
      render: (text, record) => {
        const nameWithoutTitle = record.practitioner_name?.replace('Dr. ', '');
        const [firstName, lastName] = nameWithoutTitle.split(' ');
        return (
          <>
            <div className="flex items-center ">
              <ProfileLogo
                practitionersOrgLevel={practitionersOrgLevel}
                name={`${firstName} ${lastName}`}
                className="profile-popover-logo mr-1 sm:mr-2 lg:mr-3"
                practitioner_name={nameWithoutTitle}
              />
              <div className="">{record.practitioner_name}</div>
            </div>
          </>
        );
      },
    },
    {
      title: (
        <span className="font-[700]">
          {' '}
          Email <Sort className={'sort-icon-doctor'} />
        </span>
      ),
      dataIndex: 'practitioner_email',
      key: 'practitioner_email',
      width: '20%',
    },
    {
      title: <span className="font-[700]">Is Deleted</span>,
      dataIndex: 'is_deleted',
      key: 'is_deleted',
      width: '20%',
      render: (text) => {
        return text.toString();
      },
    },
    {
      title: '',
      key: 'actions',
      dataIndex: 'actions',
      width: '25%',
      render: (text, record) => {
        if (record.is_deleted) {
          return null;
        }
        return (
          <div
            className="mx-4"
            onClick={() => {
              setSelectedUserToDelete(record);
              setShowDeleteUserModal(true);
            }}
          >
            <DeleteIcon />
          </div>
        );
      },
    },
  ];

  return (
    <>
      <div>
        <Formik>
          {({ handleSubmit }) => (
            <Form onSubmit={handleSubmit}>
              <div className="flex flex-col sm:flex-row lg:justify-between justify-center items-center">
                <div className="flex justify-start gap-12"></div>
              </div>
              <div>
                <div className="lg:w-full">
                  <div className="bg-white p-5 rounded-2xl mt-5">
                    <div className="flex justify-between">
                      <div className="text-lg font-semibold text-[#000] mb-5">
                        Select practitioner that you want to remove
                      </div>
                    </div>

                    <SuperAdminTable
                      className={`appointment-page-table`}
                      columns={columns}
                      data={practitionersOrgLevel}
                      loading={tableLoader}
                    />
                  </div>
                </div>
                {showDeleteUserModal && (
                  <Modal
                    open={showDeleteUserModal}
                    onCancel={handleCloseModal}
                    footer={null}
                    width="30vw"
                    className="text-xs"
                  >
                    <div className="flex">
                      <AlertIcon />
                      <span className="mx-4 font-semibold text-lg">
                        Confirmation
                      </span>
                    </div>

                    <div className="content my-8">
                      <p>
                        Are you sure you want to remove{' '}
                        <strong>
                          {selectedUserToDelete.practitioner_name}
                        </strong>{' '}
                        from your organization?
                      </p>
                      <p>This action can not be undone.</p>
                    </div>

                    <div className="footer flex items-center">
                      <Button
                        type="button"
                        onClick={() => {
                          removeUser(selectedUserToDelete);
                        }}
                        className="px-4 py-2 bg-[#d63232] hover:bg-[#a30000] rounded-md"
                      >
                        Proceed
                      </Button>
                      <Button
                        type="button"
                        onClick={handleCloseModal}
                        className="px-4 py-2 bg-[#00D090] hover:bg-[#059669] rounded-md mx-2"
                      >
                        Cancel
                      </Button>
                    </div>
                  </Modal>
                )}
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </>
  );
};

export default ManageUsersPage;
